import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';


@Component({
  selector: 'app-quicksight-dashboard',
  standalone: true,
  imports: [RouterModule
 
  ],
  templateUrl: './quicksight-dashboard.component.html',
  styleUrl: './quicksight-dashboard.component.scss'
})
export class QuicksightDashboardComponent {

  quickSightResourceList;
  isChildRoute = true;
  clientId = 0;
  isPartner: boolean;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private utilities: UtilitiesService,
  ) {
    this.clientId = this.utilities.clientId;
    this.checkIfChildRoute();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkIfChildRoute();
      }
    })
    this.isPartner = this.utilities.isPartnerValue;
    if(this.isPartner) {
      this.router.navigate(['client', this.utilities.clientId, 'quicksight', 'partner-dashboard']);
    } else {
      this.router.navigate(['client', this.utilities.clientId, 'quicksight', 'dashboard']);
    }
  }

  ngOnInit() {
  
  }

  checkIfChildRoute() {
    if (this.route.children.length == 1) {
      this.isChildRoute = true;
    }
    else {
      this.retrieveTableList();
      this.isChildRoute = false;
    }
  }

  retrieveTableList() {
    this.quickSightResourceList = this.utilities.menuList.filter((x) => x.name == 'QuickSight')[0].subMenu
    this.quickSightResourceList = this.quickSightResourceList.map((x) => { return { name: x.name, url: x.url.replace('quicksight/', '') } })
  }
}